

document.addEventListener('DOMContentLoaded', function() {
  function getSentencesBetween(description) {
    const startWord = "من";
    const endWord = "كيلو";
    const sentences = [];

    if (!description || !description.includes(startWord) || !description.includes(endWord)) {
      return sentences;
    }

    let startIndex = 0;
    while (startIndex !== -1) {
      startIndex = description.indexOf(startWord, startIndex);
      if (startIndex === -1) {
        break;
      }

      let endIndex = description.indexOf(endWord, startIndex + startWord.length);
      if (endIndex === -1) {
        break;
      }
      endIndex += endWord.length;

      let sentence = description.substring(startIndex, endIndex);
      let cleanSentence = sentence
        .replace(/<[^>]*>/g, "")
        .replace(/[^\p{L}\p{N}\s.!?]/gu, "")
        .replace(/\s+/g, " ")
        .trim();

      if ((cleanSentence.match(/\d+/g) || []).length >= 2) {
        sentences.push(cleanSentence);
      }

      startIndex = endIndex;
    }

    return sentences;
  }

  function displaySentenceChips(description, targetSelector) {
    const extractedSentences = getSentencesBetween(description);

    const chipsContainer = document.createElement("div");
    chipsContainer.style.display = "flex";
    chipsContainer.style.flexWrap = "wrap";
    chipsContainer.style.gap = "5px";

    extractedSentences.forEach((sentence) => {
      const chip = document.createElement("div");
      chip.style.display = "inline-flex";
      chip.style.alignItems = "center";
      chip.style.justifyContent = "center";
      chip.style.padding = "8px 16px";
      chip.style.border = "1px solid #ffa000";
      chip.style.borderRadius = "8px";
      chip.style.backgroundColor = "#fff";
      chip.style.color = "#222";
      chip.style.fontWeight = "600";
      chip.style.fontSize = "14px";
      chip.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
      chip.style.width = "100%";
      chip.style.textAlign = "center";
      chip.style.marginTop = "5px";
      chip.style.marginBottom = "5px";

      chip.innerHTML = `<span>مقاس واحد (فري سايز) &mdash; <span style="color: #ffa000; margin-right: 4px;">${sentence}</span></span>`;
      chipsContainer.appendChild(chip);
    });

    const targetElement = document.querySelector(targetSelector);
    if (targetElement) {
      targetElement.appendChild(chipsContainer);
    } else {
      document.body.appendChild(chipsContainer); // Fallback
    }
  }

  // Get the product description from the Liquid variable
  const productDescriptionElement = document.querySelector('.t4s-rte');
  if (productDescriptionElement) {
    const productDescription = productDescriptionElement.textContent;
    const extractedSentences = getSentencesBetween(productDescription);

    if(extractedSentences.length <=1) {
      displaySentenceChips(productDescription, '.product-description-target');
    }
    else {
        let filteredDescription = productDescription.replace(/من.*?كيلو/g, '');
        displaySentenceChips(filteredDescription, '.product-description-target');
    }
  }

});